export default __webpack_public_path__ + "static/media/CreditCounselingUploadImage.b4a2af18.svg";